<template>
  <div class='body-box marginBox2'>
    <el-row class='plan'></el-row>

    <el-form
      ref='editFormRef'
      :model='editForm'
      label-width='140px'
      style='padding: 20px;background-color: #fff;margin-top: 10px;'
    >
      <el-row>

        <!--预约人-->
        <el-col :span='8'>

          <el-form-item label='预约人'>
            <el-input v-model='editForm.userName' />
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span='8'>
          <el-form-item label='预约人电话'>
            <el-input v-model='editForm.tel' />
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span='8'>
          <el-form-item label='预约人邮箱'>
            <el-input v-model='editForm.email' />
          </el-form-item>
        </el-col>

        <!--组数-->
        <el-col :span='8'>
          <el-form-item label='平均分'>
            <el-input v-model='editForm.score' />
          </el-form-item>
        </el-col>
        <!--班车-->
        <el-col :span='8'>
          <el-form-item label='巴士'>
            <el-select v-model='editForm.bus' clearable placeholder='请选择巴士' style='width: 100%'>
              <el-option v-for='item in shuttleBus' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--宴会-->
        <el-col :span='8'>
          <el-form-item label='宴会'>
            <el-select v-model='editForm.food' clearable placeholder='请选择宴会' style='width: 100%'>
              <el-option v-for='item in banquet' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--協賛品提供-->
        <el-col :span='8'>
          <el-form-item label='協賛品提供'>

            <el-select v-model='editForm.provision' clearable placeholder='请选择協賛品提供' style='width: 100%'>
              <el-option key='YES' label='あり' value='YES'></el-option>
              <el-option key='NO' label='なし' value='NO'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--vip-->
        <el-col :span='8'>
          <el-form-item label='球場会員'>
            <el-select v-model='editForm.vip' clearable placeholder='请选择球場会員' style='width: 100%' >
              <el-option key='YES' label='はい' value='YES'></el-option>
              <el-option key='NO' label='いいえ' value='NO'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--成绩表-->
        <el-col :span='8'>
          <el-form-item label='領取書'>
            <el-select v-model='editForm.gradeTable' clearable placeholder='请选择領取書' style='width: 100%' >
              <el-option key='YES' label='要' value='YES'></el-option>
              <el-option key='NO' label='不要' value='NO'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span='24'>
          <el-form-item label='备注'>
            <el-input type='textarea' v-model='editForm.brief' />
          </el-form-item>
        </el-col>

        <!--修改打球人-->
        <el-col :span='24' style='padding: 20px 58px;font-size: 16px'>
          <span>打球列表:</span>
          <el-button style='margin-left: 10px' size='small' round @click='addGroup'>添加分组</el-button>
        </el-col>
        <el-col :span='24' style='margin-bottom: 30px;' v-for='(item,index) in editForm.groupPerson' :key='item.type'>
          <el-row>
            <el-col style='margin-left: 136px;'>
              <span style='margin-right: 20px'>第{{item.type}}组</span>
              <el-tag
                style='margin-right: 50px;margin-top: 15px'
                v-for="(tag, tagIndex) in item.data"
                size='medium'
                :key="tag.name"
                @close='removeUser(index, tagIndex)'
                closable>
                {{tag.name}}
              </el-tag>
              <template>
                <span class='el-icon-remove-outline'
                      style='font-size: 20px;cursor: pointer;margin-left: 5px'
                      @click='deleteContactPersons(index)'></span>
                <span class='el-icon-circle-plus-outline'
                      style='margin-left: 10px;font-size: 20px;cursor: pointer;'
                      @click='openAddUserDialog(index)'></span>
              </template>

            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <!--添加打球人-->
    <el-dialog
      title='添加打球人'
      :visible.sync='dialogVisible'
      width='30%'>
      <el-input v-model='name' placeholder='请输入打球人姓名' style='width: 100%'></el-input>
      <span slot='footer' class='dialog-footer'>
            <el-button @click='dialogVisible = false' size='small' round>取 消</el-button>
            <el-button type='primary' @click='addGroupPerson' size='small' round>确 定</el-button>
          </span>
    </el-dialog>

    <div class="goBackBox">
      <el-button @click='goBack'>返回</el-button>
      <el-button @click='submitModifyOrder'>修改订单</el-button>
    </div>
  </div>
</template>

<script>
import { modifyRacesApplyById } from '@/api/race/raceRaise'
import { raceWay, calculation, gradeTable, raceFood, shuttleBus,banquet } from '@/js/enum'
import Template from '@/views/template/template.vue'

export default {
  name: 'updateGameOrder',
  components: { Template },
  data() {
    return {
      dialogVisible: false,
      openAddUserIndex: undefined,
      name: '',
      editForm: {},
      groupPerson: [],
      orderId: '',
      newContent: {},
      newGroupPerson: [],
      raceWay: raceWay,
      calculation: calculation,
      gradeTable: gradeTable,
      raceFood: raceFood,
      shuttleBus: shuttleBus,
      banquet: banquet,
      contactPersons: []
    }
  },

  mounted() {
    this.orderId = this.$route.query.id
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      let data = localStorage.getItem(this.orderId)
      if (data) {
        this.editForm = JSON.parse(data)
      } else {
        this.$message.info('获取比赛数据失败!')
      }
    },
    //返回
    goBack() {
      this.$router.go(-1)
    },

    //替换打球人
    replace() {
      this.groupPerson = this.newGroupPerson
    },

    submitModifyOrder() {


      let data = {
        bus: this.editForm.bus,
        userId: this.editForm.userId,
        score: this.editForm.score,
        provision: this.editForm.provision,
        raceRaiseId: this.editForm.raceRaiseId,
        gradeTable: this.editForm.gradeTable,
        brief: this.editForm.brief,
        tel: this.editForm.tel,
        email: this.editForm.email,
        vip: this.editForm.vip,
        food: this.editForm.food,
        userName: this.editForm.userName,
      }
      let arr = []
      let index = 1;
      for (let group of this.editForm.groupPerson) {
        if (group.data && group.data.length > 0) {
          group.type = index
          index++
          arr.push(group)
        }
      }
      data.groupPerson = JSON.stringify(arr)

      modifyRacesApplyById(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功!')
          localStorage.removeItem(this.orderId)
          this.goBack()
        }
      })
    },
    removeUser(index, userIndex) {
      console.log('this.', this.editForm.groupPerson)
      this.editForm.groupPerson[index].data.splice(userIndex, 1)
    },
    openAddUserDialog(index) {
      this.openAddUserIndex = index
      this.dialogVisible = true
    },
    //添加打球人
    addGroupPerson() {
      if (this.name === '') {
        this.$message.info('请输入打球人姓名!')
        return
      }
      this.editForm.groupPerson[this.openAddUserIndex].data.push({name: this.name})
      this.dialogVisible = false

    },
    //删除一组
    deleteContactPersons(index) {

      this.editForm.groupPerson.splice(index, 1)
    },
    addGroup() {
      this.editForm.groupPerson.push({type: 2, data: []})
    }

  }
}
</script>

<style lang='less' scoped>
.colorStatus {
  color: red;
}
</style>
